import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'swb-form-group',
  templateUrl: './form-group.component.html'
})
export class FormGroupComponent implements OnInit {
  @Input() field: any;
  @Input() form: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
